/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { PermissionToEntitiesMap } from "./PermissionToEntitiesMap";
import { CoralModel, modelRegistrySingleton, } from "@amzn/ihm-js-coral-client";
/**
 * <pre><code>Output for GetAuthorizedEntities API
 * permissionToEntitiesMap - respresents all the Entities that user have access to at each permission level
 * entity- holds values related to the filterType
 * <\/code><\/pre>
 **/
export class GetAuthorizedEntitiesOutput extends CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedEntitiesOutput#clone(obj: PlainObjectFrom<GetAuthorizedEntitiesOutput>) method.
     */
    constructor(__permissionToEntitiesMap) {
        super();
        this.permissionToEntitiesMap = __permissionToEntitiesMap;
    }
    /**
     * Create a shallow clone of GetAuthorizedEntitiesOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */
    static clone(obj) {
        return new GetAuthorizedEntitiesOutput(obj.permissionToEntitiesMap);
    }
    static fromJson(data) {
        return new GetAuthorizedEntitiesOutput((($$val) => $$val == undefined
            ? undefined
            : PermissionToEntitiesMap.fromJson($$val))(data.permissionToEntitiesMap));
    }
    static toJson(data) {
        return Object.assign({
            permissionToEntitiesMap: (($$val) => $$val == undefined ? null : PermissionToEntitiesMap.toJson($$val))(data.permissionToEntitiesMap),
        });
    }
}
GetAuthorizedEntitiesOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetAuthorizedEntitiesOutput";
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(GetAuthorizedEntitiesOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedEntitiesOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateGetauthorizedentitiesoutput(data) {
    // TODO: Actually implement this!
    return data;
}
